import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CastIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cast"}/>
}
